module.exports = __webpack_public_path__ + "static/media/NT_101682_42_0001_A-DOSIMEX.df779bb6.pdf";